const initialState = {
  data: [],
};

const service = (state = initialState, action) => {
  switch (action.type) {
    case "SERVICE_LIST":
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default service;
